"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var RadixTooltip = __importStar(require("@radix-ui/react-tooltip"));
var react_1 = require("@stitches/react");
var stitches_config_1 = require("../stitches.config");
var Text_1 = require("./Text");
var StyledTooltipContent = (0, react_1.styled)(RadixTooltip.Content, {
    padding: "6px 8px",
    background: stitches_config_1.theme.colors.gray12,
    color: stitches_config_1.theme.colors.white,
    borderRadius: "6px",
    maxWidth: "100vw",
});
function Tooltip(props) {
    var _a;
    return ((0, jsx_runtime_1.jsx)(RadixTooltip.Provider, __assign({ delayDuration: 0 }, { children: (0, jsx_runtime_1.jsxs)(RadixTooltip.Root, __assign({ open: props.hide ? false : undefined }, { children: [(0, jsx_runtime_1.jsx)(RadixTooltip.Trigger, __assign({ asChild: true }, { children: props.children })), (0, jsx_runtime_1.jsxs)(StyledTooltipContent, __assign({ side: (_a = props.position) !== null && _a !== void 0 ? _a : "top" }, { children: [(0, jsx_runtime_1.jsxs)(Text_1.Text, __assign({ variant: "text-xs" }, { children: [" ", props.text] })), (0, jsx_runtime_1.jsx)(RadixTooltip.Arrow, {})] }))] })) })));
}
exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip.js.map